import { Navigate } from 'react-router-dom';
import { isAuthenticated } from './ProtectedRoute';

const DEFAULT_AUTHENTICATED_PATH = '/ota-details/machine-details';

const PublicRoute = ({ children }) => {
    if (isAuthenticated()) {
        return <Navigate to={DEFAULT_AUTHENTICATED_PATH} replace />;
    }

    return children;
};

export default PublicRoute;
